import { postSangjoQuotationRequestQuotation } from "@/apis/sangjoQuotation";
import { HEADER_HEIGHT } from "@/constants/components";
import { css } from "@emotion/react";
import { Lottie } from "@toss/lottie";
import { VStack } from "goi_common";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
const defaultTexts = [
  <>
    장례에
    <br />
    온전히 집중할 수 있는
    <br />
    장례지도사를 추천드려요.
  </>,
  <>
    전화상담은 장례준비의 <br />
    핵심이에요.
    <br />
    부담없이 전화해보세요
  </>,
  <>
    장례지도사님이
    <br />
    24시간 대기중이에요.
    <br />이 순간부터 장지까지 <br />
    함께해드려요.
  </>,
];
function MatchRecommendationMoreContainer() {
  const router = useRouter();
  const { id } = router.query;

  const handleSubmit = async () => {
    if (id) {
      await postSangjoQuotationRequestQuotation(String(id))
        .then((res) => {
          if (res.status == 201) {
            router.replace(`/match/recommendation/${res.data}`);
          }
        })
        .catch(() => {
          router.replace("/match/recommendations/");
        });
    } else {
      router.replace("/match/recommendations/");
    }
  };
  const [textIndex, setTextIndex] = useState(0);

  useEffect(() => {
    const totalTime = 4000;
    const intervalTime = totalTime / defaultTexts.length;

    const intervalId = setInterval(() => {
      setTextIndex((prev) => {
        if (prev >= defaultTexts.length - 1) return defaultTexts.length - 1;
        return prev + 1;
      });
    }, intervalTime);

    setTimeout(() => {
      clearInterval(intervalId);
      handleSubmit();
    }, totalTime);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  if (!router.isReady) return null;

  return (
    <>
      <VStack
        padding="20px"
        alignItems="center"
        justifyContent="center"
        css={[rootCss, { height: `calc(var(--vh, 1vh) * 100 - ${HEADER_HEIGHT}px)` }]}
      >
        <>
          <div css={textCss.container}>
            {defaultTexts.map((text, index) => (
              <div
                key={index}
                className="head2_b gray900 font-center"
                css={[textCss.self, { opacity: index === textIndex ? 1 : 0 }]}
              >
                {text}
              </div>
            ))}
          </div>

          <div css={lottie1Css}>
            <Lottie src="/lotties/LOADING-1.json" width="100px" height="100px" loop={true} />
          </div>
          <Lottie src="/lotties/LOADING-2.json" width="245px" loop={true} />
        </>
        <div className="body_14_m gray500 font-center">
          최선의 서비스를 추천하기 위해
          <br />
          열심히 일하는 중이에요
        </div>
      </VStack>
    </>
  );
}

const rootCss = css({
  paddingBottom: "35.96vh",
});
const lottie1Css = css({
  height: "20px",
});

const textCss = {
  container: css({
    width: "100%",
    position: "relative",
  }),
  self: css({
    position: "absolute",
    transition: "0.5s opacity",
    bottom: 0,
    left: 0,
    right: 0,
  }),
};

export default MatchRecommendationMoreContainer;
